import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { 
  FaBuilding, 
  FaTools, 
  FaUsers, 
  FaTruck,
  FaCheckCircle,
  FaCalendarAlt,
  FaMapMarkerAlt
} from "react-icons/fa";
import project1 from "../../assest/Residenatl-3.png";
import project2 from "../../assest/Residental-2.png";
import project3 from "../../assest/Residenatl-3.png";
import project4 from "../../assest/Commercial-1.png";
import project5 from "../../assest/Commercial-2.png";
import project6 from "../../assest/Commerical-3.png";

const services = [
  { 
    title: "General Contracting", 
    icon: <FaBuilding size={40} />,
    description: "End-to-end construction management from planning to completion"
  },
  { 
    title: "Equipment Rental", 
    icon: <FaTools size={40} />,
    description: "Modern construction equipment available for short and long-term rental"
  },
  { 
    title: "Manpower Supply", 
    icon: <FaUsers size={40} />,
    description: "Skilled labor force for all construction needs"
  },
  { 
    title: "Transportation Services", 
    icon: <FaTruck size={40} />,
    description: "Reliable material transportation and logistics solutions"
  },
];

const projectImages = [project1, project2, project3, project4, project5, project6];

const completedProjects = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  title: `Commercial Complex ${i + 1}`,
  description: "Completed successfully with full client satisfaction, delivered on time and within budget.",
  location: ["Dubai", "Abu Dhabi", "Sharjah"][i % 3],
  date: `202${Math.floor(i/4)}-${(i%12)+1}-${(i%28)+1}`,
  image: projectImages[i % 6]
}));

const ProjectInfo = () => {
  return (
    <div className="container py-5">
      {/* Services Section */}
      <section className="mb-5">
        <h2 className="text-center mb-4 fw-bold display-5">Our Premium Services</h2>
        <div className="row g-4">
          {services.map((service, idx) => (
            <div className="col-md-6 col-lg-3" key={idx}>
              <div className="card text-center shadow-sm h-100 border-0 hover-effect">
                <div className="card-body p-4">
                  <div className="icon-wrapper mb-3">
                    {React.cloneElement(service.icon, { 
                      className: "text-danger" 
                    })}
                  </div>
                  <h5 className="card-title fw-bold mb-3">{service.title}</h5>
                  <p className="card-text text-muted">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Projects Section */}
      <section>
        <h2 className="text-center mb-4 fw-bold display-5">Our Completed Projects</h2>
        <div className="row g-4">
          {completedProjects.map((project) => (
            <div className="col-md-6 col-lg-4" key={project.id}>
              <div className="card h-100 shadow-sm border-0 project-card">
                <div className="card-img-top overflow-hidden">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="img-fluid w-100 project-image"
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title fw-bold">{project.title}</h5>
                  <p className="card-text text-muted mb-3">{project.description}</p>
                  
                  <div className="project-details">
                    <div className="d-flex align-items-center mb-2">
                      <FaCheckCircle className="text-danger me-2" />
                      <span>Status: Completed</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <FaCalendarAlt className="text-danger me-2" />
                      <span>Date: {project.date}</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <FaMapMarkerAlt className="text-danger me-2" />
                      <span>Location: {project.location}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Custom CSS */}
      <style jsx>{`
        .hover-effect {
          transition: all 0.3s ease;
          border-radius: 10px;
        }
        .hover-effect:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
        }
        .hover-effect:hover .icon-wrapper {
          color: #dc3545 !important;
        }
        .project-card {
          transition: all 0.3s ease;
          border-radius: 10px;
          overflow: hidden;
        }
        .project-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
        }
        .project-image {
          transition: transform 0.5s ease;
          height: 200px;
          object-fit: cover;
        }
        .project-card:hover .project-image {
          transform: scale(1.05);
        }
        .icon-wrapper {
          transition: color 0.3s ease;
        }
      `}</style>
    </div>
  );
};

export default ProjectInfo;